import React, { Component } from 'react';
import googleBadge from '../../media/google-play-badge.png';
import appleBadge from '../../media/apple-store-badge.png';
import googleQRCode from '../../media/amiko-google-play.png';
import appleQRCode from '../../media/amiko-apple-store.png';

class AppPage extends Component {
    render() {
        return (
            <div className="container-flex">
				<div className="app-store">
					<div className="app-store__half">
						<div className="qr-code">
							<img className="img-responsive" src={googleQRCode} alt="https://play.google.com/store/apps/details?id=com.amikohome.smarthome" />
						</div>
						<a className="badge" href="https://play.google.com/store/apps/details?id=com.amikohome.smarthome" target="_blank">
							<img className="img-responsive" src={googleBadge} alt="Google Play Store"/>
						</a>
					</div>
					<div className="app-store__half">
						<div className="qr-code">
							<img className="img-responsive" src={appleQRCode} alt="https://itunes.apple.com/us/app/amiko-home/id1394418929?mt=8" />
						</div>
						<a className="badge" href="https://itunes.apple.com/us/app/amiko-home/id1394418929?mt=8" target="_blank">
							<img className="img-responsive" src={appleBadge} alt="Apple App Store"/>
						</a>
					</div>
				</div>
            </div>
        );
     }
}

export default AppPage;


// WEBPACK FOOTER //
// ./src/components/page/AppPage.js